"use client";

import * as React from "react";
import { Check, ChevronsUpDown } from "lucide-react";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { multiDataInterface, SelectedValue } from "@/interface/dataInterface";
import { useGetList } from "react-admin";
import { Portal } from "@radix-ui/react-popover";

const MultiSelect: React.FC<multiDataInterface> = ({ resource, dataProp, selected, setSelected, objectProps}) => {
  const { data = [] } = useGetList(resource);
  const [open, setOpen] = React.useState(false);

  const handleSelect = (id: number, value: string) => {
    if (selected.find((obj: any) => obj.id === id)) {
      setSelected((prev: SelectedValue[]) => prev.filter((item) => item.id !== id));
    } else {
      if (!objectProps) {  
        setSelected((prev: SelectedValue[]) => [...prev, {id, name: value}]);
        return;
      }
      const objTarget = data.filter(item => id === item.id)[0]
      let objToSet: any = {}
      objectProps.map(prop => objToSet[prop] = objTarget[prop])
      setSelected((prev: any) => [...prev, {id, ...objToSet}])
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger className="w-full" asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-full justify-between"
        >
          {selected.length} selected
          <ChevronsUpDown className="opacity-50" />
        </Button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent className="w-full z-[99] pointer-events-auto p-0">
        <Command className="w-full">
          <CommandInput id="permissions" name="permissions" placeholder="Search..." className="h-9" required/>
          <CommandList>
            <CommandEmpty>No result.</CommandEmpty>
            <CommandGroup>
              {data && data.length > 0 &&
                data.map((item) => (
                  <CommandItem
                    className="cursor-pointer text-foreground"
                    key={item.id}
                    value={item.id}
                    onSelect={() => handleSelect(item.id, item[dataProp])}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    {item[dataProp]}
                    <Check
                      className={cn(
                        "ml-auto",
                        selected.some(aItem => aItem.id === item.id) ? "opacity-100" : "opacity-0",
                      )}
                    />
                  </CommandItem>
                ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default MultiSelect
